var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { forIn } from 'lodash';
import { TypesManager, Type } from './type';
import * as services from './services';
import { getStore } from './store';
import { registerSaga } from './sagas';
import { Parser } from './parser';
import { ComponentsManager, EntitiesManager, RoutesManager } from './parser';
import * as Loader from './loaders';
import * as ErrorHandle from './services/error-handle';
import * as actions from './actions';
import { language as languagePackage } from './languages'; // import './index.scss';

var navigation = services.navigation,
    language = services.language,
    globalConfig = services.globalConfig;
/**
 *
 * @example
 *
 * builder.init({ 'api.token': 'demo-api-token', 'features.i18n': true });
 * builder.registerComponent(something);
 * builder.registerType(something);
 * builder.registerLoader(something);
 * builder.registerEntity(something);
 * builder.registerSaga(something);
 * builder.registerLanguage(something);
 *
 * ReactDOM.render(builder.bootstrap(EntryComponent), document.getElementById('app'));
 */

var builder = {
  /**
   * 初始化
   *
   * 先将配置项写入 `globalConfig`, 然后初始化相关模块
   *
   * @param configs 配置项键值对
   */
  init: function init(configs) {
    forIn(configs, function (param, key) {
      globalConfig.set(key, param);
    });
    language.init();
    navigation.init();
  },

  /**
   * 引导框架
   *
   * @param EntryComponent 入口组件
   */
  bootstrap: function bootstrap(EntryComponent) {
    var history = builder.getHistory();
    var routes = builder.getRoutes();
    var store = builder.getStore();
    var props = {
      history: history,
      routes: routes,
      store: store
    };
    return history ? React.createElement(EntryComponent, __assign({}, props)) : React.createElement("div", null, "bootstrap failed.");
  },

  /**
   * 添加新配置
   *
   * 已有路由中若存在与新路由中相同 path 的节点，会进行节点子路由合并，新路由节点不会替换已有路由节点。
   *
   * @param config 配置文件
   */
  registerConfig: Parser.parse,

  /**
   * 注册组件
   * @param name 组件名称
   * @param component 组件类定义
   */
  registerComponent: ComponentsManager.register,

  /**
   * 注册一个实体
   * @param name 实体名称
   * @param desc 实体的描述信息
   */
  registerEntity: EntitiesManager.register,

  /**
   * 注册新类型
   * @param name 类型名称
   * @param type 类型实例
   */
  registerType: TypesManager.register,

  /**
   * 注册新的加载器
   * @param apiPath 加载器处理的 url，不包含 /loader/ 前缀
   * @param loader 加载器定义
   */
  registerLoader: Loader.registerLoader,

  /**
   * 注册新的 saga
   * @param saga 初始化生成器
   */
  registerSaga: registerSaga,

  /**
   * 注册新语言信息
   *
   * 当语言已存在时，新注册的语言信息会合并至旧语言信息中
   *
   * @param languagePackage 语言信息
   */
  registerLanguage: language.registerLanguage,

  /**
   * 配置errorHandle
   */
  replaceErrorHandle: ErrorHandle.replaceErrorHandle,

  /**
   * 获取 redux store
   */
  getStore: getStore,

  /**
   * 获取历史
   */
  getHistory: navigation.getHistory,

  /**
   * 获取路由配置
   */
  getRoutes: RoutesManager.getRoutes
};
export { builder, globalConfig, services, actions, TypesManager, ComponentsManager, EntitiesManager, RoutesManager, languagePackage, Type, Loader };
export default builder;